import React from "react";

const BackgroundDark: React.FC = () => {
  return (
    <svg
      width="308"
      height="235"
      viewBox="0 0 308 235"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_15274_2152)">
        <path
          d="M223.064 88.6659C259.335 34.6826 308 16 308 16V235L20 235C20 235 23.4379 208.168 45.5 195.41C86.2297 171.856 94.1149 175.364 137.134 175.364C192.765 175.364 203.339 118.022 223.064 88.6659Z"
          fill="#9DE3FB"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15274_2152"
          x="0"
          y="0"
          width="328"
          height="259"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15274_2152"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15274_2152"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default BackgroundDark;
